import { IFileRemovePayload, IUploadedFilesState } from "@telstra-connect/shared-payloads/file-upload";
import {  ICartInfoState } from "../state/cart";
import { ICurrencyState } from "../state/currency-exchange-rate";

export const groupBy = (inputArray, keyName: string) => {
    const groupedData = inputArray.reduce((groupedArray, item) => {
        const key = item[keyName] ? item[keyName].trim() : "unavailable";
        groupedArray[key] = groupedArray[key] ?? [];
        groupedArray[key].push(item);
        return groupedArray;
    }, {});
    return groupedData;
};


export const getTotalCartItemsCharge = (cartData: ICartInfoState,priceList, currencyRate: ICurrencyState): number => {
    return cartData?.data?.reduce((previousValue, cartItem) => {
        let orderCharge=0;
        // tslint:disable-next-line:forin
        for (const key in cartItem.cableInfo)
        {
            if(priceList.data[cartItem.cableInfo[key].connectorState.sku]){
                orderCharge+=
                (Math.ceil((Number(priceList.data[cartItem.cableInfo[key].connectorState.sku].estimatedMRC) * Number(currencyRate.data.convertedAmount))) +
                (Math.ceil((Number(priceList.data[cartItem.cableInfo[key].connectorState.sku].estimatedNRC)*Number(currencyRate.data.convertedAmount)))))
            }
        }
        return Math.ceil(Number((Number(previousValue) + Number(orderCharge))*10)/10);
    }, 0);
}

export const getTotalReccurringCharge = (cartData: ICartInfoState,priceList, currencyRate: ICurrencyState): number => {
    return cartData?.data?.reduce((previousValue, cartItem) => {
        let orderCharge=0;
        // tslint:disable-next-line:forin
        for (const key in cartItem.cableInfo)
        {
            if(priceList.data[cartItem.cableInfo[key].connectorState.sku]){
                orderCharge+=
                Number(priceList.data[cartItem.cableInfo[key].connectorState.sku].estimatedMRC)*Number(currencyRate.data.convertedAmount)
            }
        }
        return Math.ceil(Number((Number(previousValue) + Number(orderCharge))*10)/10);
    }, 0);
}

export const getTotalOneOffCharge = (cartData: ICartInfoState,priceList, currencyRate: ICurrencyState): number => {
    return cartData?.data?.reduce((previousValue, cartItem) => {
        let orderCharge=0;
        // tslint:disable-next-line:forin
        for (const key in cartItem.cableInfo)
        {
            if(priceList.data[cartItem.cableInfo[key].connectorState.sku]){
                orderCharge+=
                Number(priceList.data[cartItem.cableInfo[key].connectorState.sku].estimatedNRC)*Number(currencyRate.data.convertedAmount)
            }
        }
        return Math.ceil(Number((Number(previousValue) + Number(orderCharge))*10)/10);
    }, 0);  
}

export const getFilteredFilesList = (uploadedFiles:IUploadedFilesState, popId: string): IUploadedFilesState=>{
delete uploadedFiles[popId];
return uploadedFiles;
}

export const getRemovedFilesList = (uploadedFiles:IUploadedFilesState, data:IFileRemovePayload): IUploadedFilesState=>{
    const requiredFiles = []
    uploadedFiles[data.popId].forEach((ele)=>{
        if(data.fileName !== ele.fileName){
            requiredFiles.push(ele)
        }
    })
    uploadedFiles[data.popId] = requiredFiles
    return uploadedFiles;
    }
